import * as React from 'react';
// ModalInfo is intentionally imported directly — the molecules barrel export
// of it causes a white-screen crash (see ui-react/CLAUDE.md).
import ModalInfo from '../molecules/ModalInfo';

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
}

const MESSAGE =
  'Changing the jurisdiction may impact existing inspections. The current inspection types may ' +
  'not exist in the new jurisdiction. Please review your scheduled inspections before proceeding. ' +
  'Would you like to update the jurisdiction?';

const JurisdictionChangeConfirmModal = ({ onConfirm, onCancel }: Props) => (
  <ModalInfo
    isError
    title="Change Jurisdiction?"
    message={MESSAGE}
    timeToClose={0}
    onClose={onCancel}
    primaryLabel="Yes"
    onPrimary={onConfirm}
    secondaryLabel="No"
    onSecondary={onCancel}
  />
);

export default JurisdictionChangeConfirmModal;
